import { FC, ReactElement } from 'react';

import { Link } from 'react-router-dom';

import { Badge } from '../../../../components';
import { LinkIconButton } from '../../../../compositions';
import { Customer } from '../../../../entities/@account/Customer/Customer';
import { AppRoute, appRoutes } from '../../../../entities/Routing/Routing';
import { useTrans } from '../../../../hooks';

import './AccountControls.scss';

interface AccountControlsProps {
    isAuthenticated: boolean;
    wishlistIsLoading: boolean;
    wishlistItemsCount: number;
    customer?: Customer;
    className?: string;
}

export const AccountControls: FC<AccountControlsProps> = ({
    isAuthenticated,
    wishlistIsLoading,
    wishlistItemsCount,
    customer,
    className = '',
}): ReactElement => {
    const trans = useTrans();

    const firstLetterOfCustomerName = customer?.firstName.charAt(0) || '';

    const wishlistRoute = isAuthenticated
        ? trans(appRoutes[AppRoute.accountWishlist].path)
        : trans(appRoutes[AppRoute.wishlist].path);

    return (
        <div className={`account-controls ${className}`}>
            {isAuthenticated ? (
                <Link
                    to={trans(appRoutes[AppRoute.accountDashboard].path)}
                    className="account-controls__link"
                >
                    <span className="account-controls__link-icon account-controls__account-avatar">
                        {firstLetterOfCustomerName}
                    </span>
                </Link>
            ) : (
                <LinkIconButton
                    hideLabel
                    to={trans(appRoutes[AppRoute.login].path)}
                    icon="user"
                    text={trans('containers.menu.accountDashboard')}
                    className="account-controls__link"
                    iconClassName="account-controls__link-icon"
                />
            )}

            <div className="account-controls__link-wrapper">
                <LinkIconButton
                    hideLabel
                    to={wishlistRoute}
                    icon="heart"
                    text={trans('containers.menu.wishlist')}
                    className="account-controls__link"
                    iconClassName="account-controls__link-icon"
                />

                <Badge
                    isLoading={wishlistIsLoading}
                    count={wishlistItemsCount}
                />
            </div>
        </div>
    );
};
